import { WSTableCell } from "@wingspanhq/fe-component-library";
import { PersonStatus, Stakeholder } from "@wingspanhq/wingspan-api-sdk";
import * as React from "react";
import { useStakeholderPerson } from "./useStakeholderPerson";

type Props = {
  stakeholder: Stakeholder;
};

export const StakeholderStatusCell: React.FC<Props> = props => {
  const queryPerson = useStakeholderPerson(props.stakeholder);
  const status = queryPerson.data?.status;

  if (status === PersonStatus.ACTIVE) {
    return (
      <WSTableCell
        pill={{
          theme: "success",
          icon: true,
          text: "Signed up"
        }}
      />
    );
  }

  return (
    <WSTableCell
      pill={{
        theme: "warning",
        icon: true,
        text: "Not signed up"
      }}
    />
  );
};
